import * as React from "react";

import DenseTable from "./DenseTable";
import API from "../Api/api";
import { LineWave } from "react-loader-spinner";
import { Radio } from "antd";
import YearSummaryReport from "./SummaryYear";
import moment from "moment";

const columns = [
  { id: "asset_pool", label: "Category", width: 2000 },

  {
    id: "accum_depreciation",
    label: "Accum. Dpn",
    width: 200,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "carrying_amount",
    label: "Carrying Amnt",
    width: 170,
    align: "left",
  },
  {
    id: "depreciation",
    label: "Dpn",
    width: 170,
    align: "left",
  },
];
const column2 = [
  { id: "asset_pool", label: "Category", width: 500 },

  {
    id: "accum_depreciation",
    label: "Accum. Amtz",
    width: 200,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "carrying_amount",
    label: "Carrying Amnt",
    width: 170,
    align: "left",
  },
  {
    id: "depreciation",
    label: "Amortization",
    width: 170,
    align: "left",
  },
];
const column3 = [
  { id: "asset_pool", label: "Category", width: 500 },

  {
    id: "accum_depreciation",
    label: "Accum. Dpn",
    width: 200,
    align: "left",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "carrying_amount",
    label: "Carrying Amnt",
    width: 170,
    align: "left",
  },
  {
    id: "depreciation",
    label: "Dpn",
    width: 170,
    align: "left",
  },
];

function getFirstAndLastDateOfMonth(year, month) {
  // First day of the month
  const firstDate = new Date(year, month, 1);

  // Last day of the month
  const lastDate = new Date(year, month + 1, 0);

  return {
    firstDate,
    lastDate,
  };
}

export default function SummaryReport() {
  const [value, setValue] = React.useState("month");
  const onChange = (e) => {
    setValue(e.target.value);
  };

  const yearIn = new Date().getFullYear();
  const monthIn = new Date().getMonth();

  const { firstDate, lastDate } = getFirstAndLastDateOfMonth(yearIn, monthIn);

  const depreciation_end = `&depreciation_end=${lastDate}`;

  const depreciation_start = `&depreciation_start=${firstDate}`;

  function createData(
    asset_pool,
    cost,
    accum_depreciation,
    carrying_amount,
    depreciation
  ) {
    return {
      asset_pool,
      cost,
      accum_depreciation,
      carrying_amount,
      depreciation,
    };
  }

  const [data, setData] = React.useState([]);

  const query = `/api/v1/company-assets/get-asset-by-code/code?disposed=false&approved=true${depreciation_end}${depreciation_start}`;

  // ! A function to fetch queried data from the database//---------start------------

  let currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
  });
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const res = await API.get(query);
      setData(res.data);
      setLoading(false);
    };
    fetch();
  }, []);

  function filterAndCalculate(assets) {
    // Group and calculate costs by category
    const groupedData = assets.reduce((acc, asset) => {
      const category = asset.category;

      // Initialize category if not present
      if (!acc[category]) {
        acc[category] = {
          cost: 0,
          accum_depre: 0,
          carrying_amount: 0,
          depreciation: 0,
        };
      }

      acc[category].cost += asset.cost;
      acc[category].accum_depre += asset.accum_depre;
      acc[category].carrying_amount += asset.carrying_amount;
      acc[category].depreciation += asset.depreciation;

      return acc;
    }, {});

    return groupedData;
  }

  // Example: Calculate costs between 2023-01-01 and 2023-12-31
  const neededData = data.filter(
    (d) => d.category !== "intangibles" && d.category !== "right-of-use asset"
  );
  const neededData2 = data.filter((d) => d.category === "intangibles");

  const neededData3 = data.filter(
    (d) =>
      d.category === "right-of-use asset" &&
      moment(d.exhaustion_date) >= moment(firstDate)
  );

  const result = filterAndCalculate(neededData);
  const results2 = filterAndCalculate(neededData2);
  const results3 = filterAndCalculate(neededData3);
  const rows2 = Object.entries(result).map(([category, data]) =>
    createData(
      category,
      currencyFormatter.format(data.cost),
      currencyFormatter.format(data.accum_depre),
      currencyFormatter.format(data.carrying_amount),
      currencyFormatter.format(data.depreciation)
    )
  );
  const rows3 = Object.entries(results2).map(([category, data]) =>
    createData(
      category,
      currencyFormatter.format(data.cost),
      currencyFormatter.format(data.accum_depre),
      currencyFormatter.format(data.carrying_amount),
      currencyFormatter.format(data.depreciation)
    )
  );
  const rows4 = Object.entries(results3).map(([category, data]) =>
    createData(
      category,
      currencyFormatter.format(data.cost),
      currencyFormatter.format(data.accum_depre),
      currencyFormatter.format(data.carrying_amount),
      currencyFormatter.format(data.depreciation)
    )
  );

  // Optionally, add the total row
  const totalData = {
    cost: Object.values(result).reduce((sum, item) => sum + item.cost, 0),
    accum_depre: Object.values(result).reduce(
      (sum, item) => sum + item.accum_depre,
      0
    ),
    carrying_amount: Object.values(result).reduce(
      (sum, item) => sum + item.carrying_amount,
      0
    ),
    depreciation: Object.values(result).reduce(
      (sum, item) => sum + item.depreciation,
      0
    ),
  };

  rows2.push(
    createData(
      "Total",
      currencyFormatter.format(totalData.cost),
      currencyFormatter.format(totalData.accum_depre),
      currencyFormatter.format(totalData.carrying_amount),
      currencyFormatter.format(totalData.depreciation)
    )
  );

  if (loading === true) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <LineWave
          visible={true}
          height="100"
          width="100"
          color="#4fa94d"
          ariaLabel="line-wave-loading"
          wrapperStyle={{}}
          wrapperClass=""
          firstLineColor=""
          middleLineColor=""
          lastLineColor=""
        />
        <span>Loading Summary report for this month....</span>
      </div>
    );
  }
  if (loading === false) {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: "5px",
            justifyContent: "space-between",
          }}
        >
          <span>Your summary report for this {value} </span>
          <Radio.Group onChange={onChange} value={value}>
            <Radio value={"month"}>Month</Radio>
            <Radio value={"year"}>Year</Radio>
          </Radio.Group>
        </div>
        {/* ------------------ */}
        {value === "month" ? (
          <div>
            <DenseTable rows={rows2} headers={columns} filename={"summary"} />
            <div>
              <strong style={{ fontSize: "12px" }}>INTANGIBLES</strong>
            </div>
            <DenseTable rows={rows3} headers={column2} filename={"summary"} />

            <div>
              <strong style={{ fontSize: "12px" }}>RIGHT-OF-USE ASSETS</strong>
            </div>
            <DenseTable rows={rows4} headers={column3} filename={"summary"} />
          </div>
        ) : (
          <div>
            <YearSummaryReport />
          </div>
        )}
      </div>
    );
  }
}
